import { Text } from '@naf/text';
import styled from '@emotion/styled';

export const TextWithNewLine = styled(Text)`
  white-space: break-spaces;
`;

export const BoldText = styled(Text)`
  font-weight: 700;
`;
